/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal back-reference to the expression_ccl link embedded inside SAP expressions
 * @export
 * @interface ExprCclRef
 */
export interface ExprCclRef {
    /**
     * 
     * @type {number}
     * @memberof ExprCclRef
     */
    expressionCclId?: number;
    /**
     * 
     * @type {number}
     * @memberof ExprCclRef
     */
    conclusionGroupId: number;
    /**
     * 
     * @type {number}
     * @memberof ExprCclRef
     */
    expressionId: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExprCclRef
     */
    isMarked: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExprCclRef
     */
    expressionOrder: number;
}

/**
 * Check if a given object implements the ExprCclRef interface.
 */
export function instanceOfExprCclRef(value: object): value is ExprCclRef {
    if (!('conclusionGroupId' in value) || value['conclusionGroupId'] === undefined) return false;
    if (!('expressionId' in value) || value['expressionId'] === undefined) return false;
    if (!('isMarked' in value) || value['isMarked'] === undefined) return false;
    if (!('expressionOrder' in value) || value['expressionOrder'] === undefined) return false;
    return true;
}

export function ExprCclRefFromJSON(json: any): ExprCclRef {
    return ExprCclRefFromJSONTyped(json, false);
}

export function ExprCclRefFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExprCclRef {
    if (json == null) {
        return json;
    }
    return {
        
        'expressionCclId': json['expressionCclId'] == null ? undefined : json['expressionCclId'],
        'conclusionGroupId': json['conclusionGroupId'],
        'expressionId': json['expressionId'],
        'isMarked': json['isMarked'],
        'expressionOrder': json['expressionOrder'],
    };
}

export function ExprCclRefToJSON(json: any): ExprCclRef {
    return ExprCclRefToJSONTyped(json, false);
}

export function ExprCclRefToJSONTyped(value?: ExprCclRef | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expressionCclId': value['expressionCclId'],
        'conclusionGroupId': value['conclusionGroupId'],
        'expressionId': value['expressionId'],
        'isMarked': value['isMarked'],
        'expressionOrder': value['expressionOrder'],
    };
}

